import PropTypes from 'prop-types';
import { CommonIDPropType } from './common';

const MaskedIdentityPropType = PropTypes.shape({
  id: CommonIDPropType,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  company: PropTypes.string,
  position: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string
});

export default MaskedIdentityPropType;
